import { IImage } from "@faire/web-api/indigofair/data/IImage";
import { optimizeImageUrlFillRectangle } from "@faire/web/common/images/optimizeImages";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";

import {
  IMAGES,
  KEYWORDS,
  getURLFromKeyword,
} from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/consts";

export interface BannerImageDimensions {
  height: string;
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
}
export interface IBannerImage {
  src: string;
  zIndex: number;
  dimensions: { [viewport: string]: BannerImageDimensions };
}

const convertToOptimizedImage = (
  url: string | undefined,
  isSSR: boolean,
  width: number,
  height: number
): string => {
  return (
    optimizeImageUrlFillRectangle(
      IImage.build({
        url: url,
      }),
      isSSR,
      width,
      height
    ) ?? ""
  );
};

export const useGetBottomSignUpBannerImages = (): {
  images: IBannerImage[];
  keyword: KEYWORDS;
}[] => {
  const isSSR = useIsSSR();

  return IMAGES().map((currentVariant) => {
    const { imageUrls, keyword } = currentVariant;
    const [image0, image1, image2, image3] = imageUrls;
    const IMAGES = [
      {
        src: convertToOptimizedImage(image0, isSSR, 213, 273),
        zIndex: 2,
        dimensions: {
          xlarge: {
            height: "273px",
            top: "0",
            left: "10%",
          },
          desktop: {
            height: "258px",
            top: "0",
            left: "10%",
          },
          tablet: {
            height: "176px",
            top: "0",
            left: "7%",
          },
          mobile: {
            height: "0",
            top: "0",
            left: "0",
          },
        },
      },
      {
        src: convertToOptimizedImage(image1, isSSR, 341, 225),
        zIndex: 1,
        dimensions: {
          xlarge: {
            height: "225px",
            bottom: "7%",
            left: "0",
          },
          desktop: {
            height: "212px",
            bottom: "7%",
            left: "0",
          },
          tablet: {
            height: "145px",
            bottom: "7%",
            left: "0",
          },
          mobile: {
            height: "0",
            bottom: "0",
            left: "0",
          },
        },
      },
      {
        src: convertToOptimizedImage(image2, isSSR, 290, 330),
        zIndex: 1,
        dimensions: {
          xlarge: {
            height: "330px",
            top: "88px",
            right: "0",
          },
          desktop: {
            height: "311px",
            top: "88px",
            right: "0",
          },
          tablet: {
            height: "212px",
            top: "88px",
            right: "0",
          },
          mobile: {
            height: "265px",
            top: "0",
            right: "0",
          },
        },
      },
      {
        src: convertToOptimizedImage(image3, isSSR, 207, 232),
        zIndex: 1,
        dimensions: {
          xlarge: {
            height: "232px",
            bottom: "5%",
            right: "167px",
          },
          desktop: {
            height: "219px",
            bottom: "3%",
            right: "111px",
          },
          tablet: {
            height: "150px",
            bottom: "5%",
            right: "102px",
          },
          mobile: {
            height: "168px",
            bottom: "0",
            left: "0",
          },
        },
      },
    ];

    return {
      keyword,
      images: IMAGES,
    };
  });
};

export const useGetBottomSignUpBannerUrls = () => {
  return Object.values(KEYWORDS).map((keyword) => {
    return { keyword, url: getURLFromKeyword(keyword) };
  });
};
